// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__vl_bg","additionalInfo":"AgreementModal_additionalInfo__39UnN"};